/**
 * @file: today.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import startOfToday from 'date-fns/startOfToday';

export function today() {
  return startOfToday();
}
